module.exports = __webpack_public_path__ + "static/img/shanghaiwei1.21310b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shanghaiwei1.png
// module id = iIr6
// module chunks = 1